var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Inject } from "../di/inject";
import { DOMUtils } from "./dom/index";
var ComponentSelector = /** @class */ (function () {
    function ComponentSelector(selector, parent, shouldInitiate) {
        if (parent === void 0) { parent = 'wrapper'; }
        if (shouldInitiate === void 0) { shouldInitiate = true; }
        this.selector = selector;
        this.parent = parent;
        this.shouldInitiate = shouldInitiate;
    }
    return ComponentSelector;
}());
var ComponentSelectors = /** @class */ (function () {
    function ComponentSelectors() {
    }
    return ComponentSelectors;
}());
var ComponentObject = /** @class */ (function () {
    function ComponentObject() {
    }
    Object.defineProperty(ComponentObject.prototype, "className", {
        get: function () {
            return typeof this;
        },
        enumerable: false,
        configurable: true
    });
    return ComponentObject;
}());
var ComponentElements = /** @class */ (function () {
    function ComponentElements(selectors) {
        this.selectors = selectors;
    }
    ComponentElements.prototype.initialize = function (wrapper) {
        if (wrapper === void 0) { wrapper = null; }
        this.wrapper = wrapper;
        this.setElements();
    };
    ComponentElements.prototype.setElements = function () {
        var _this = this;
        var selectors = this.selectors;
        Object.keys(selectors).forEach(function (key) {
            if (typeof selectors[key] === 'string') {
                return;
            }
            var selector = selectors[key];
            if (!selector.shouldInitiate) {
                return;
            }
            var parent = selector.parent;
            var parentElm;
            parentElm = parent == 'document' ? document.body : _this[parent];
            if (Array.isArray(_this[key])) {
                _this[key] = _this.domUtils.getElements(selector.selector, parentElm);
            }
            else {
                _this[key] = _this.domUtils.getElement(selector.selector, parentElm);
            }
        });
    };
    ;
    __decorate([
        Inject(),
        __metadata("design:type", DOMUtils)
    ], ComponentElements.prototype, "domUtils", void 0);
    return ComponentElements;
}());
var Component = /** @class */ (function () {
    function Component(elements, classList, texts) {
        this.elements = elements;
        this.classList = classList;
        this.texts = texts;
    }
    return Component;
}());
function ComponentInjector(selectors, elements, classList, texts) {
    return function (constructor) {
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.component = new Component(new elements(new selectors()), new classList(), new texts());
                return _this;
            }
            Object.defineProperty(class_1.prototype, "selectors", {
                get: function () {
                    return this.component.elements.selectors;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(class_1.prototype, "classList", {
                get: function () {
                    return this.component.classList;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(class_1.prototype, "elements", {
                get: function () {
                    return this.component.elements;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(class_1.prototype, "texts", {
                get: function () {
                    return this.component.texts;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(class_1.prototype, "domUtils", {
                get: function () {
                    return this.component.elements.domUtils;
                },
                enumerable: false,
                configurable: true
            });
            return class_1;
        }(constructor));
    };
}
export { Component, ComponentSelector, ComponentSelectors, ComponentObject, ComponentElements, ComponentInjector, };
//# sourceMappingURL=component.js.map